import React from "react";
import "./testimonials.scss";
export default class Testimonial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 1,
      lastClicked: 1,
      class1: "img-1",
      class2: "img-2",
      class3: "img-3",
      class4: "img-4",
      class5: "img-5",
      class6: "img-6",
      class7: "img-7",
      lastClass: ""
    };
  }

  persons = [
    {
      name: "Aman Pandoh",
      message:
        "Overall experience with Toffee Insurance was great. They did what they said, were prompt with responses and settled my claim within time. It was an experience as easy as buying a toffee indeed!",
      imgUrl: require("../../../assets/images/landing/testimonials/img-1.png")
    },
    {
      name: "Vivek Raju",
      message:
        "I always thought insurance was a cumbersome process best left to need basis. But the insurance buying process at Toffee took literally less than 5 minutes and there I was, a happy, satisfied policy buyer.",
      imgUrl: require("../../../assets/images/landing/testimonials/img-3.png")
    },
    {
      name: "Nishita Dhawan",
      message:
        "Most of the business complex/building areas do not have any dedicated parking spaces for bicycles. With the nature of my job, I realised relying on Toffee bicycle insurance was a far quicker, efficient step than requesting the guard to keep an eye on my cycle all day. It’s taken a whole load of uncertainty and stress off my head!",
      imgUrl: require("../../../assets/images/landing/testimonials/img-2.png")
    },
    {
      name: "Tarachand Maurya",
      message:
        "The whole process from submitting the claim to settling it was very easy, very supportive. Did not feel like a hassle like typical insurance policies. I’ll surely be taking other insurance products from you in the future.",
      imgUrl: require("../../../assets/images/landing/testimonials/img-4.png")
    },
    {
      name: "Saurav Sharma",
      message:
        "The dealer introduced me to Toffee Insurance and from consideration to buying the insurance, it took me all of 5 minutes. Now that’s called easy and efficient!",
      imgUrl: require("../../../assets/images/landing/testimonials/img-5.png")
    },
    {
      name: "Amit Rai",
      message:
        "The product is one-of-its-kind and I’m definitely happy with the efficiency from the claim settlement team. Would be a returning customer!",
      imgUrl: require("../../../assets/images/landing/testimonials/img-6.png")
    },
    {
      name: "Tripesh Goel",
      message:
        "The product is unique, relevant and most of all, easy to our needs. The best part was their easy process that took just a week to credit my claim in my account. Would recommend it!",
      imgUrl: require("../../../assets/images/landing/testimonials/img-7.png")
    }
  ];

  imageClicked(num) {
    // this.setState({
    //   current: num,
    //   lastClicked: 'img-' + num
    // })
    // const num = this.state.class1.split('-')[]
    console.log(num);
    switch (num) {
      case 1:
        this.setState(
          {
            class1: "img-1",
            current: num,
            lastClass: this.state.class1
          },
          () => {
            this.changeOneClass(this.state.lastClicked, num);
          }
        );
        break;
      case 2:
        this.setState(
          {
            class2: "img-1",
            current: num,
            lastClass: this.state.class2
          },
          () => {
            this.changeOneClass(this.state.lastClicked, num);
          }
        );
        break;
      case 3:
        this.setState(
          {
            class3: "img-1",
            current: num,
            lastClass: this.state.class3
          },
          () => {
            this.changeOneClass(this.state.lastClicked, num);
          }
        );
        break;
      case 4:
        this.setState(
          {
            class4: "img-1",
            current: num,
            lastClass: this.state.class4
          },
          () => {
            this.changeOneClass(this.state.lastClicked, num);
          }
        );
        break;
      case 5:
        this.setState(
          {
            class5: "img-1",
            current: num,
            lastClass: this.state.class5
          },
          () => {
            this.changeOneClass(this.state.lastClicked, num);
          }
        );
        break;
      case 6:
        this.setState(
          {
            class6: "img-1",
            current: num,
            lastClass: this.state.class6
          },
          () => {
            this.changeOneClass(this.state.lastClicked, num);
          }
        );
        break;
      case 7:
        this.setState(
          {
            class7: "img-1",
            current: num,
            lastClass: this.state.class7
          },
          () => {
            this.changeOneClass(this.state.lastClicked, num);
          }
        );
        break;
      default:
        break;
    }
    // this.changeOneClass(this.state.lastClicked, num)
  }
  changeOneClass(last, current) {
    console.log(last, current);
    switch (last) {
      case 1:
        this.setState({
          class1: this.state.lastClass,
          lastClicked: current
        });
        break;
      case 2:
        this.setState({
          class2: this.state.lastClass,
          lastClicked: current
        });
        break;
      case 3:
        this.setState({
          class3: this.state.lastClass,
          lastClicked: current
        });
        break;
      case 4:
        this.setState({
          class4: this.state.lastClass,
          lastClicked: current
        });
        break;
      case 5:
        this.setState({
          class5: this.state.lastClass,
          lastClicked: current
        });
        break;
      case 6:
        this.setState({
          class6: this.state.lastClass,
          lastClicked: current
        });
        break;
      case 7:
        this.setState({
          class7: this.state.lastClass,
          lastClicked: current
        });
        break;
      default:
        break;
    }

    // this.setState({
    //   lastClicked: current
    // })
  }
  previousClicked() {
    this.state.current > 1 && this.imageClicked(this.state.current - 1);
  }
  nextClicked() {
    this.state.current < 7 && this.imageClicked(this.state.current + 1);
  }
  render() {
    return (
      <div className="testimonials-container">
        <h2 className="title opacity-90 text-center">
          99.1% Claim Settlement Rate
        </h2>
        <h3 className="sub-title text-center mb-mobile-70">
          People everywhere love Toffee
        </h3>
        <div className="animatio-box">
          <img
            className="bg-image"
            src={require("../../../assets/images/landing/testimonials/test-bg.svg")}
            alt=""
          />
          <div
            className="bg-image-mobile"
            // src={require("../../../assets/images/landing/testimonials/test-bg-mobile.svg")}
            // alt=""
          ></div>
          {this.persons.map((person, index) => {
            return this.state.current - 1 === index ? (
              <p key={"person_name_" + index} className="name">
                {" "}
                {person.name}
              </p>
            ) : (
              ""
            );
          })}
          {this.persons.map((person, index) => {
            return this.state.current - 1 === index ? (
              <p key={"person_message_" + index} className="message">
                {person.message}
              </p>
            ) : (
              ""
            );
          })}
          <img
            onClick={e => {
              e.preventDefault();
              this.imageClicked(1);
            }}
            src={this.persons[0].imgUrl}
            alt=""
            className={this.state.class1}
          />
          <img
            onClick={e => {
              e.preventDefault();
              this.imageClicked(2);
            }}
            src={this.persons[1].imgUrl}
            alt=""
            className={this.state.class2}
          />
          <img
            onClick={e => {
              e.preventDefault();
              this.imageClicked(3);
            }}
            src={this.persons[2].imgUrl}
            alt=""
            className={this.state.class3}
          />
          <img
            onClick={e => {
              e.preventDefault();
              this.imageClicked(4);
            }}
            src={this.persons[3].imgUrl}
            alt=""
            className={this.state.class4}
          />
          <img
            onClick={e => {
              e.preventDefault();
              this.imageClicked(5);
            }}
            src={this.persons[4].imgUrl}
            alt=""
            className={this.state.class5}
          />
          <img
            onClick={e => {
              e.preventDefault();
              this.imageClicked(6);
            }}
            src={this.persons[5].imgUrl}
            alt=""
            className={this.state.class6}
          />
          <img
            onClick={e => {
              e.preventDefault();
              this.imageClicked(7);
            }}
            src={this.persons[6].imgUrl}
            alt=""
            className={this.state.class7}
          />
          <div className="next-btns">
            <img
              onClick={e => {
                e.preventDefault();
                this.previousClicked();
              }}
              className={
                this.state.current > 1
                  ? "opacity-100 cursor-pointer"
                  : "opacity-50"
              }
              src={require("../../../assets/images/landing/testimonials/previous.svg")}
              alt=""
            />
            <img
              onClick={e => {
                e.preventDefault();
                this.nextClicked(7);
              }}
              className={
                this.state.current < 7
                  ? "opacity-100 cursor-pointer"
                  : "opacity-50"
              }
              src={require("../../../assets/images/landing/testimonials/next.svg")}
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }
}
